module.exports = __webpack_public_path__ + "img/price-list-intro-pic.d34d18bf.png";